export const CUSTOMER_REVIEW_IMAGES = [
  '/image/customer-reviews/review-1.jpg',
  '/image/customer-reviews/review-2.jpg',
  '/image/customer-reviews/review-3.jpg',
  '/image/customer-reviews/review-4.jpg',
  '/image/customer-reviews/review-5.jpg',
  '/image/customer-reviews/review-6.jpg',
  '/image/customer-reviews/review-7.jpg',
  '/image/customer-reviews/review-8.jpg',
  '/image/customer-reviews/review-9.jpg',
];
